(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .controller('RecomUpdateStatusAssessByActionPlanReviewController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'topBarService', 'bUnit', 'govProcess', 'assessmentsByActionPlan', 'fiscalYearQuarterKeys'];

    function Controller($scope, $state, $stateParams, topBarService, bUnit, govProcess, assessmentsByActionPlan, fiscalYearQuarterKeys) {

        if (redirectToCriterias(assessmentsByActionPlan)) {
            $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias', { 
                ActionPlanID: $stateParams.ActionPlanID
            }, {
                reload: true
            });
        }

        var title = bUnit.TitleEN + ' Action Plans | ' + govProcess.ShortName + ' Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        $scope.bUnit = bUnit;
        $scope.govProcess = govProcess;

        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.fiscalYearQuarterKeys = fiscalYearQuarterKeys;

        $scope.actionPlanAssessment   = assessmentsByActionPlan.ActionPlanAssessment;
        $scope.actionPlan             = assessmentsByActionPlan.ActionPlan;
        $scope.actionPlanStatusList   = assessmentsByActionPlan.ActionPlanStatusList;
        $scope.aPlanAssessmentSummary = assessmentsByActionPlan.ActionPlanAssessmentSummary;

        function redirectToCriterias(assessmentsByActionPlan) {
            if (_.isUndefined(assessmentsByActionPlan.ActionPlanAssessment)) return false;

            return !assessmentsByActionPlan.ActionPlanAssessment.AreAllCriteriasReviewed;
        }
    }
})();